import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { TREND_SCORE } from '../../../constant'

export const Trend = ({ data }) => {
  if (data.toUpperCase() === TREND_SCORE.DOWN) {
    return (
      <Element>
        <Icon
          className="icon-arrow-down-circle"
          style={{ color: '#E0505B', fontSize: 20 }}
        />
      </Element>
    )
  }
  if (data.toUpperCase() === TREND_SCORE.UP) {
    return (
      <Element>
        <Icon
          className="icon-arrow-up-circle"
          style={{ color: '#3DA967', fontSize: 20 }}
        />
      </Element>
    )
  }

  return (
    <Element>
      <Icon
        className="icon-arrow-right-circle"
        style={{ color: '#006AA6', fontSize: 20 }}
      />
    </Element>
  )
}
